import axios from "axios";
import { csrfToken } from "./csrf";

const axiosInstance = axios.create();
axiosInstance.defaults.headers.common["X-CSRF-Token"] = csrfToken();

export { axiosInstance as axiosPost };
